import {
  AppShell,
  MobileTopBar,
  Sidebar,
  SidebarBrand,
  SidebarSkeleton,
  Skeleton,
  TopBar,
} from '@/components/ui';
import { PanelPageSkeleton } from '@/components/admin/panel-page-skeleton';
import { pageSkeletonFor } from '@/lib/page-skeleton-route';

const noop = () => undefined;

/** The three round buttons of the top bar (theme, bell, help). */
function ActionsSkeleton() {
  return (
    <>
      {Array.from({ length: 3 }).map((_, i) => (
        <Skeleton key={i} className="size-9" />
      ))}
    </>
  );
}

/**
 * The whole panel before anything is known: sidebar, top bar and the skeleton
 * of the page at `pathname`. It is what the first paint of `/admin/*` shows
 * (session hydrating, the layout's chunk downloading), so it flows into the real
 * shell instead of replacing it. Static: not focusable and hidden from
 * assistive tech, with one announcement beside it.
 */
export function ShellSkeleton({ pathname }: { pathname: string }) {
  return (
    <>
      <div data-admin-shell inert aria-hidden="true">
        <AppShell
          sidebar={
            <Sidebar>
              <SidebarBrand as="div" />
              <SidebarSkeleton />
            </Sidebar>
          }
          topBar={
            <TopBar
              crumbs={<Skeleton className="h-4 w-40" />}
              search={<Skeleton className="h-[38px] w-full" />}
              actions={<ActionsSkeleton />}
            />
          }
          mobileBar={<MobileTopBar onMenu={noop} actions={<ActionsSkeleton />} />}
        >
          <PanelPageSkeleton variant={pageSkeletonFor(pathname)} />
        </AppShell>
      </div>
      <span role="status" className="sr-only">
        Cargando
      </span>
    </>
  );
}
